import React from 'react';
import { FormattedMessage } from 'react-intl';
import DataLoadError from 'components/DataLoadError';
import styles from './ApplicationShell.module.scss';

export default function ApplicationLoadingError() {
  return (
    <DataLoadError
      className={styles.error}
      message={<FormattedMessage id="DATA_LOAD_ERROR" />}
    />
  );
}

ApplicationLoadingError.displayName = 'ApplicationLoadingError';
